<template>
  <div class="aigc-login">
    <div class="aigc-login-bg">
      <video
        class="aigc-login-video"
        :src="loginVideo"
        autoplay
        muted
        loop
        playsinline
      />
      <div class="aigc-login-bg-mask" />
    </div>

    <van-nav-bar
      title=""
      left-arrow
      :border="false"
      class="aigc-login-nav"
      @click-left="onNavBack"
    />

    <div class="aigc-login-body">
      <div class="aigc-login-slogan">
        <h1 class="aigc-login-slogan-title">白云AI漫剧一站式创作平台</h1>
        <p class="aigc-login-slogan-desc">
          一键生成创意图片、视频，助力短剧、电商等场景快速产出所需素材，<br />
          小成本成就大爆款，您的专属短剧工作室
        </p>
      </div>

      <div class="aigc-login-main">
        <div class="aigc-login-card">
          <div class="aigc-login-fields">
        <van-field
          v-model="form.mobile"
          class="aigc-login-field"
          type="tel"
          maxlength="11"
          clearable
          :border="false"
          label="+86"
          label-width="3em"
          placeholder="请输入手机号"
          @keyup.enter.native="onSubmit"
        />
        <van-field
          ref="smsField"
          v-model="form.smsCode"
          class="aigc-login-field"
          center
          clearable
          maxlength="6"
          :border="false"
          label="验证码"
          label-width="3.2em"
          placeholder="短信验证码"
          @keyup.enter.native="onSubmit"
        >
          <button
            slot="button"
            type="button"
            class="aigc-login-code-btn"
            :disabled="codeDisabled || sendingCode"
            @click="onSendCode"
          >
            <van-loading v-if="sendingCode" size="14px" color="#fff" />
            <span v-else>{{ codeBtnText }}</span>
          </button>
        </van-field>
      </div>

      <div class="aigc-login-agree">
        <van-checkbox
          v-model="form.agreed"
          icon-size="16px"
          shape="square"
          checked-color="#5B7FFF"
        >
          <span class="aigc-login-agree-text">
            我同意
            <a href="javascript:;" class="aigc-login-link" @click.stop.prevent="onAgreement">用户协议</a>
            和
            <a href="javascript:;" class="aigc-login-link" @click.stop.prevent="onPrivacy">隐私政策</a>
          </span>
        </van-checkbox>
      </div>

      <van-button
        block
        round
        color="#5B7FFF"
        native-type="button"
        class="aigc-login-submit"
        loading-text="登录中..."
        :loading="submitting"
        :disabled="submitting"
        @click="onSubmit"
      >
        注册 / 登录
      </van-button>
        </div>
      </div>
    </div>

    <van-popup
      v-model="captchaModalVisible"
      round
      closeable
      get-container="body"
      :z-index="3000"
      class="aigc-login-captcha-popup"
      @close="closeCaptchaModal"
    >
      <div class="aigc-login-captcha-modal">
        <h3 class="aigc-login-captcha-title">安全验证</h3>
        <p class="aigc-login-captcha-desc">请输入图形验证码，验证通过后将自动发送短信验证码</p>
        <div class="aigc-login-captcha-row">
          <input
            ref="captchaInputRef"
            v-model="captchaInput"
            type="text"
            class="aigc-login-captcha-input"
            placeholder="图形验证码"
            maxlength="6"
            @keyup.enter="onCaptchaConfirm"
          />
          <div class="aigc-login-captcha-box" title="点击刷新" @click="refreshCaptcha">
            <img v-if="captchaUrl" class="aigc-login-captcha-img" :src="captchaUrl" alt="图形验证码" />
            <span v-else class="aigc-login-captcha-placeholder">加载中</span>
          </div>
        </div>
        <div class="aigc-login-captcha-actions">
          <van-button round block plain type="default" @click="closeCaptchaModal">取消</van-button>
          <van-button
            round
            block
            color="#5B7FFF"
            :loading="verifyingCaptcha"
            loading-text="验证中..."
            :disabled="verifyingCaptcha || !captchaInput.trim()"
            @click="onCaptchaConfirm"
          >
            确认
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import loginVideo from "./assets/login.mp4";

export default {
  name: "AigcLogin",
  data() {
    return {
      loginVideo,
      form: {
        mobile: "",
        smsCode: "",
        agreed: false,
      },
      codeCountdown: 0,
      sendingCode: false,
      verifyingCaptcha: false,
      captchaKey: "",
      captchaInput: "",
      captchaModalVisible: false,
      submitting: false,
      codeTimer: null,
    };
  },
  watch: {
    "form.mobile"(val, oldVal) {
      const mobile = String(val || "").trim();
      const oldMobile = String(oldVal || "").trim();
      if (mobile !== oldMobile) {
        this.form.smsCode = "";
        this.codeCountdown = 0;
        if (this.codeTimer) {
          clearInterval(this.codeTimer);
          this.codeTimer = null;
        }
        this.closeCaptchaModal();
      }
    },
  },
  computed: {
    codeDisabled() {
      return this.codeCountdown > 0 || !/^1[3-9]\d{9}$/.test(this.form.mobile);
    },
    codeBtnText() {
      return this.codeCountdown > 0 ? `${this.codeCountdown}秒后重发` : "获取验证码";
    },
    captchaUrl() {
      const mobile = this.form.mobile.trim();
      if (!this.captchaKey || !/^1[3-9]\d{9}$/.test(mobile)) return "";
      return `${this.getLmBaseURL()}/user/captcha/?mobile=${encodeURIComponent(mobile)}&t=${this.captchaKey}`;
    },
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  beforeDestroy() {
    document.body.style.overflow = "";
    if (this.codeTimer) clearInterval(this.codeTimer);
  },
  methods: {
    getLmBaseURL() {
      return (process.env.LM_BASE_URL || "").replace(/\/+$/, "");
    },
    onNavBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.replace({ name: "aigc_create" });
      }
    },
    refreshCaptcha() {
      this.captchaInput = "";
      this.captchaKey = `${Date.now()}-${Math.floor(Math.random() * 1000000)}`;
    },
    openCaptchaModal() {
      this.captchaInput = "";
      this.captchaModalVisible = true;
      this.refreshCaptcha();
      this.$nextTick(() => {
        const el = this.$refs.captchaInputRef;
        if (el && typeof el.focus === "function") el.focus();
      });
    },
    closeCaptchaModal() {
      this.captchaModalVisible = false;
      this.captchaInput = "";
      this.verifyingCaptcha = false;
    },
    onSendCode() {
      if (this.codeDisabled || this.sendingCode || this.verifyingCaptcha) return;
      const mobile = this.form.mobile.trim();
      if (!/^1[3-9]\d{9}$/.test(mobile)) {
        this.$toast("请输入正确的手机号");
        return;
      }
      this.openCaptchaModal();
    },
    async onCaptchaConfirm() {
      if (this.verifyingCaptcha || this.sendingCode) return;
      const mobile = this.form.mobile.trim();
      const captcha = this.captchaInput.trim();
      if (!/^1[3-9]\d{9}$/.test(mobile)) {
        this.$toast("请输入正确的手机号");
        return;
      }
      if (!captcha) {
        this.$toast("请输入图形验证码");
        return;
      }
      this.verifyingCaptcha = true;
      this.sendingCode = true;
      try {
        const verifyResp = await this.Axios({
          baseURL: this.getLmBaseURL(),
          url: "/user/verify_captcha/",
          method: "get",
          params: { mobile, captcha },
        });
        const verifyBody = verifyResp.data || {};
        if (verifyBody.status !== 1) {
          this.$toast.fail(verifyBody.error_msg || "图形验证码错误");
          this.refreshCaptcha();
          return;
        }
        const resp = await this.Axios({
          baseURL: this.getLmBaseURL(),
          url: "/user/send_sms/",
          method: "post",
          data: { mobile },
        });
        const body = resp.data || {};
        if (body.status === 1) {
          this.closeCaptchaModal();
          this.$toast.success("验证码已发送");
          this.codeCountdown = 90;
          if (this.codeTimer) clearInterval(this.codeTimer);
          this.codeTimer = setInterval(() => {
            this.codeCountdown -= 1;
            if (this.codeCountdown <= 0) {
              clearInterval(this.codeTimer);
              this.codeTimer = null;
            }
          }, 1000);
          this.$nextTick(() => {
            const root = this.$refs.smsField;
            const input = root && root.$el && root.$el.querySelector("input");
            if (input && typeof input.focus === "function") input.focus();
          });
        } else {
          this.$toast.fail(body.error_msg || "发送失败");
          this.refreshCaptcha();
        }
      } catch (e) {
        const msg =
          (e.response && e.response.data && e.response.data.error_msg) || "发送失败";
        this.$toast.fail(msg);
        this.refreshCaptcha();
      } finally {
        this.verifyingCaptcha = false;
        this.sendingCode = false;
      }
    },
    navigateAfterLogin() {
      const raw = this.$route.query.redirect;
      if (raw) {
        try {
          const path = decodeURIComponent(String(raw));
          if (path.charAt(0) === "/") {
            this.$router.replace(path);
            return;
          }
        } catch (e) {
          /* ignore */
        }
      }
      this.$router.replace({ name: "aigc_create" });
    },
    pickLmDisplayName(data) {
      const d = data && typeof data === "object" ? data : {};
      const candidates = [
        d.baicloud_name,
        d.name,
        d.nickname,
        d.nick_name,
        d.user_name,
        d.userName,
        d.real_name,
        d.realName,
        d.auth_name,
        d.weixin_nickname,
        d.mobile,
        d.phone,
      ];
      for (let i = 0; i < candidates.length; i += 1) {
        const s = candidates[i] != null ? String(candidates[i]).trim() : "";
        if (s && s.toLowerCase() !== "undefined" && s.toLowerCase() !== "null") return s;
      }
      return "";
    },
    setCookiesAndRedirect(data, mobileFallback) {
      const raw = data && typeof data === "object" ? data : {};
      const merged = { ...raw };
      const fb = mobileFallback != null ? String(mobileFallback).trim() : "";
      if (fb && !merged.mobile) merged.mobile = fb;
      const displayName = this.pickLmDisplayName(merged);

      const exp = new Date();
      exp.setTime(exp.getTime() + 1000 * (raw.expire_time || 30 * 24 * 3600) + 8 * 3600 * 1000);
      const isProd = window.location.host.indexOf("ibaicloud.com") !== -1;
      const domainPart = isProd && raw.domain ? `;Domain=${raw.domain}` : "";
      const opts = `expires=${exp.toGMTString()};Path=/${domainPart}`;
      const token = raw.token || raw.front_token || raw.baicloud_token || "";
      document.cookie = `front_token=${token};${opts}`;
      const userId =
        raw.baicloud_user_id != null && String(raw.baicloud_user_id).trim() !== ""
          ? raw.baicloud_user_id
          : raw.uid != null
            ? raw.uid
            : "";
      document.cookie = `front_userId=${userId};${opts}`;
      document.cookie = `front_userName=${encodeURIComponent(displayName)};${opts}`;

      try {
        const u = this.$store.state.user;
        this.$store.commit("updateUser", {
          ...u,
          user_id: String(userId !== "" ? userId : u.user_id || ""),
          user_name: displayName || u.user_name || "",
          mobile: String(merged.mobile != null ? merged.mobile : u.mobile || ""),
          loginStatus: true,
        });
      } catch (e) {
        /* ignore */
      }

      this.navigateAfterLogin();
    },
    pickApiErrorMsg(payload) {
      const p = payload && typeof payload === "object" ? payload : {};
      const nested = p.data && typeof p.data === "object" ? p.data : {};
      const candidates = [
        p.msg,
        p.error_msg,
        p.message,
        nested.msg,
        nested.error_msg,
        nested.message,
      ];
      for (let i = 0; i < candidates.length; i += 1) {
        const s = candidates[i] != null ? String(candidates[i]).trim() : "";
        if (s) return s;
      }
      return "";
    },
    formatLoginErrorMsg(payload) {
      const reason = this.pickApiErrorMsg(payload);
      return reason ? `登录失败：${reason}` : "登录失败";
    },
    async onSubmit() {
      if (this.submitting) return;
      const mobile = this.form.mobile.trim();
      const smsCode = this.form.smsCode.trim();
      if (!/^1[3-9]\d{9}$/.test(mobile)) {
        this.$toast("请输入正确的手机号");
        return;
      }
      if (!smsCode) {
        this.$toast("请输入短信验证码");
        return;
      }
      if (!this.form.agreed) {
        this.$toast("请阅读并同意用户协议和隐私政策");
        return;
      }
      this.submitting = true;
      try {
        const resp = await this.Axios({
          baseURL: this.getLmBaseURL(),
          url: "/user/login/",
          method: "post",
          data: { mobile, code: smsCode },
        });
        const body = resp.data || {};
        if (body.status === 1) {
          this.$toast.success("登录成功");
          this.setCookiesAndRedirect(body.data || {}, this.form.mobile.trim());
          return;
        }
        this.submitting = false;
        this.$toast.fail(this.formatLoginErrorMsg(body));
      } catch (e) {
        this.submitting = false;
        const resp = e.response;
        const data = resp && resp.data;
        this.$toast.fail(this.formatLoginErrorMsg(data));
      }
    },
    onAgreement() {
      const base = (process.env.TEMPLATE_URL || "").replace(/\/+$/, "");
      if (base) window.open(`${base}/domain/agreement/`, "_blank");
    },
    onPrivacy() {
      const base = (process.env.TEMPLATE_URL || "").replace(/\/+$/, "");
      if (base) window.open(`${base}/domain/protect/`, "_blank");
    },
  },
};
</script>

<style scoped>
.aigc-login {
  --aigc-primary: #7a9cff;
  --aigc-code-bg: rgba(91, 127, 255, 0.85);
  --aigc-line: rgba(255, 255, 255, 0.2);
  position: fixed;
  inset: 0;
  z-index: 1;
  min-height: 100vh;
  min-height: 100dvh;
  background: #0f1419;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.aigc-login-bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  overflow: hidden;
}

.aigc-login-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.aigc-login-bg-mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1;
}

.aigc-login-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 5;
  background-color: transparent !important;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
}

.aigc-login-nav >>> .van-nav-bar__content {
  height: 44px;
}

.aigc-login-nav >>> .van-nav-bar__title {
  display: none;
}

.aigc-login-nav >>> .van-nav-bar__text,
.aigc-login-nav >>> .van-icon {
  color: #fff;
}

.aigc-login-body {
  position: relative;
  z-index: 2;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-top: calc(44px + env(safe-area-inset-top, 0px));
  padding-top: calc(44px + constant(safe-area-inset-top, 0px));
}

.aigc-login-slogan {
  flex-shrink: 0;
  text-align: left;
  padding: 50px 22px 8px;
  background: transparent;
}

.aigc-login-slogan-title {
  margin: 0 0 12px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.35;
  color: #fff;
  letter-spacing: 0.5px;
  text-shadow: 0 1px 10px rgba(0, 0, 0, 0.55);
}

.aigc-login-slogan-desc {
  margin: 0;
  max-width: none;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.92);
  text-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}

.aigc-login-main {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-height: 0;
  box-sizing: border-box;
  padding: 40px 20px 20px;
}

.aigc-login-card {
  width: 100%;
  max-width: 400px;
  position: relative;
  z-index: 3;
  padding: 20px;
  border-radius: 20px;
  background: rgba(18, 22, 30, 0.52);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.aigc-login-fields {
  border-radius: 0;
}

.aigc-login-field {
  padding: 4px 0;
  background: transparent;
  border-bottom: 1px solid;
}

.aigc-login-field >>> .van-field {
  background: transparent;
}

.aigc-login-field >>> .van-cell {
  padding: 14px 0;
  line-height: 24px;
  background-color: transparent !important;
}

.aigc-login-field >>> .van-field__label {
  color: rgba(255, 255, 255, 0.88);
  font-size: 15px;
  width: 3em;
}

.aigc-login-field >>> .van-field__label + .van-field__value .van-field__control,
.aigc-login-field >>> .van-field__control {
  font-size: 15px;
  color: #fff;
}

.aigc-login-field >>> .van-field__control::placeholder {
  color: rgba(255, 255, 255, 0.42);
}

.aigc-login-field >>> .van-icon {
  color: rgba(255, 255, 255, 0.55);
}

.aigc-login-field >>> .van-cell::after {
  border-bottom: 1px solid var(--aigc-line);
  right: 0;
  left: 0;
}

.aigc-login-code-btn {
  flex-shrink: 0;
  min-width: 88px;
  height: 32px;
  padding: 0 12px;
  margin-left: 8px;
  border: none;
  border-radius: 8px;
  background: var(--aigc-code-bg);
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.aigc-login-code-btn:disabled {
  opacity: 0.5;
}

.aigc-login-agree {
  margin-top: 18px;
  padding: 2px 0;
}

.aigc-login-agree >>> .van-checkbox__label {
  line-height: 22px;
}

.aigc-login-agree >>> .van-checkbox__icon .van-icon {
  border-color: rgba(255, 255, 255, 0.45);
}

.aigc-login-agree-text {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.55;
}

.aigc-login-link {
  color: #a8c4ff;
  font-weight: 500;
}

.aigc-login-submit {
  margin-top: 24px;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  /* box-shadow: 0 6px 20px rgba(91, 127, 255, 0.35); */
}

.aigc-login-submit.van-button--disabled {
  opacity: 0.65;
}

.aigc-login-submit >>> .van-button__text {
  font-weight: 600;
}

.aigc-login-captcha-popup {
  width: 88%;
  max-width: 360px;
}

.aigc-login-captcha-modal {
  padding: 24px 20px 20px;
}

.aigc-login-captcha-title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  text-align: center;
}

.aigc-login-captcha-desc {
  margin: 0 0 18px;
  font-size: 13px;
  color: #909399;
  text-align: center;
  line-height: 1.5;
}

.aigc-login-captcha-row {
  display: flex;
  align-items: stretch;
  gap: 10px;
  margin-bottom: 20px;
}

.aigc-login-captcha-input {
  flex: 1;
  min-width: 0;
  height: 44px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  font-size: 15px;
  color: #303133;
  background: #fff;
  box-sizing: border-box;
}

.aigc-login-captcha-input::placeholder {
  color: #c0c4cc;
}

.aigc-login-captcha-box {
  flex-shrink: 0;
  width: 110px;
  height: 44px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f7fa;
  cursor: pointer;
}

.aigc-login-captcha-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: #909399;
}

.aigc-login-captcha-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.aigc-login-captcha-actions {
  display: flex;
  gap: 12px;
}

.aigc-login-captcha-actions >>> .van-button {
  flex: 1;
  height: 42px;
}
</style>



// WEBPACK FOOTER //
// src/views/aigc/AigcLogin.vue